import { useRef, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './richtext.css';

export default function RichTextEditor({ value, onChange }: any) {
  const quillRef = useRef<any>(null);

  useEffect(() => {
    const editor = quillRef.current?.getEditor();
    if (!editor) return;

    editor.on('text-change', () => {
      const html = editor.root.innerHTML;

      const fixed = html.replace(/href="(?!https?:\/\/)([^"]+)"/g, 'href="https://$1"');

      if (fixed !== html) {
        editor.root.innerHTML = fixed;
      }
    });
  }, []);

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
    ],
  };

  return (
    <div className="border border-gray-200 rounded-xl">
      <ReactQuill
        placeholder="Description"
        ref={quillRef}
        value={value}
        onChange={onChange}
        modules={modules}
        theme="snow"
        className="custom-quill"
      />
    </div>
  );
}
